<template>
	<header class="bg-white border-b min-h-[100px] flex-none">
		<div
			:class="contentClasses"
			class="flex items-center justify-between p-8 max-w-[1000px] w-full mx-auto"
		>
			<div>
				<AppLink
					v-if="backLink"
					:to="backLink.to"
					icon="arrow_back"
					class="mb-2.5"
				>
					{{ backLink.label }}
				</AppLink>
				<div>
					<h1 v-if="title" class="text-xl">{{ title }}</h1>
					<p v-if="description" class="text-base">{{ description }}</p>
					<slot name="description" class="" />
				</div>
				<div v-if="$slots.default" class="mt-3">
					<slot />
				</div>
			</div>
			<slot name="buttons"></slot>
		</div>
	</header>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from "vue-router";

interface Props {
	title?: string;
	description?: string;
	contentClasses?: string;
	backLink?: {
		label: string;
		to: RouteLocationRaw;
	};
}
defineProps<Props>();
</script>
